export enum Gender {
  MALE = 'MR',
  FEMALE = 'MS',
}
